import {FlashsaleType} from "../../../helpers/loadFlashsales";
import {createRoot} from "react-dom/client";
import React, {Suspense} from "react";
import {useTranslation} from "react-i18next";
import FlashSaleTimer from "../../atoms/FlashSaleTimer";
import LoadingSpinner from "../../atoms/LoadingSpinner";

type RedesignFlashsaleSlideType = {
  flashSale: FlashsaleType;
  isSingleSlide: boolean;
};

export function redesignFlashsaleSlideRender(
  slideAnchor: HTMLAnchorElement,
  flashSale: FlashsaleType,
  isSingleSlide: boolean,
) {
  slideAnchor.href = flashSale.path;
  slideAnchor.dataset.gaPromoName = flashSale.headline;
  slideAnchor.dataset.gaPromoMediaId = flashSale.mediaId;

  const root = createRoot(slideAnchor);
  root.render(
    <Suspense fallback={null}>
      <RedesignFlashsaleSlide flashSale={flashSale} isSingleSlide={isSingleSlide} />
    </Suspense>,
  );
}

const RedesignFlashsaleSlide: React.FC<RedesignFlashsaleSlideType> = ({flashSale, isSingleSlide}) => {
  const {t} = useTranslation();

  const imgSrcMobile = flashSale.swiperMobileImage;
  let imgSrcDesktop = flashSale.swiperDesktopImage;
  let mediaQuery = "(min-width: 768px)";
  if (isSingleSlide) {
    mediaQuery = "(min-width: 481px)";
    imgSrcDesktop = flashSale.banner;
  }

  return (
    <>
      <div className="flash-sale__image">
        <picture>
          <source media={mediaQuery} srcSet={imgSrcDesktop} />
          <source srcSet={imgSrcMobile} />
          <img src={imgSrcMobile} alt={flashSale.imgAltText} loading="lazy" />
        </picture>
        <LoadingSpinner />
      </div>
      <div className="flash-sale__text overlay-box-vertical dark-color-box p-m-7">
        <div className="flash-sale__content position-modifier">
          <p className="text-2 text-m-3 mb-1 mb-s-3">{t("flashsale.inTheConnoxDeals")}</p>
          <h2 className="flash-sale__content__title line-clamp-three uppercase medium mb-1 mb-s-3">
            {flashSale.headline}
          </h2>
          <div className="flash-sale__timer-text text-2 text-m-3 mb-5 mb-s-7">
            <FlashSaleTimer endDateString={flashSale.endDate} />
          </div>
          <span className="flash-sale__link cta-button cta-inverse px-3">{t("flashsale.watchNow")}</span>
        </div>
      </div>
    </>
  );
};
